import React from "react";
import styles from "./PrescriptionPhoto.module.scss";
import { ReactComponent as PdfIcon } from "../../../../assets/icons/pdf-icon.svg";
import { PrescriptionResponse } from "../../../../types/shared";

type Props = {
  prescriptionLink: PrescriptionResponse;
};

const PrescriptionPhoto = ({ prescriptionLink }: Props) => {
  const fileUrl = prescriptionLink.imageLink || "";
  const fullUrl =
    process.env.REACT_APP_CDN_PATH + "prescriptions_images/" + fileUrl;
  const isPdf = fileUrl.toLowerCase().endsWith(".pdf");

  return (
    <div className={styles.PrescriptionPhoto}>
      <a
        rel="noreferrer"
        target="_blank"
        className={styles.linkWrap}
        href={fullUrl}
        title={isPdf ? "Otvori PDF" : "Pogledaj sliku"}
      >
        {isPdf ? (
          <div className={styles.pdfIconWrapper}>
            <PdfIcon className={styles.pdfIcon} />
          </div>
        ) : (
          <img alt="Recept" className={styles.image} src={fullUrl} />
        )}
      </a>
    </div>
  );
};

export default PrescriptionPhoto;
